// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Full-Screen Modal Background */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7); /* Dark overlay */
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  /* Modal Content */
  .modal-content {
    background: var(--clr-white);
    padding: 2rem;
    border-radius: var(--radius);
    box-shadow: var(--shadow-4);
    width: 90%;
    max-width: 700px;
    text-align: center;
    position: relative;
    animation: fadeIn 0.3s ease-in-out;
  }
  
  
  
  /* Close Button - Stylish & Animated */
.close-btn {
    position: absolute;
    top: 12px;
    right: 15px;
    width: 40px; /* Uniform shape */
    height: 40px;
    font-size: 1.3rem;
    background: var(--clr-primary-6); /* Soft primary color */
    color: var(--clr-white);
    border: none;
    cursor: pointer;
    border-radius: 50%; /* Perfect circle */
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.3s ease, background 0.3s ease;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2); /* Subtle shadow */
    z-index: 100;
}

/* Hover Animation */
.close-btn:hover {
    background: var(--clr-primary-4); /* Darker shade */
    transform: scale(1.1) rotate(180deg); /* Rotating effect */
}

/* Active Click Effect */
.close-btn:active {
    transform: scale(0.9); /* Shrinks slightly */
    background: var(--clr-primary-3);
}

  /* Video Player */
  .modal-content video {
    width: 100%;
    max-height: 400px;
    border-radius: var(--radius);
    margin-top: 10px;
  }
  
  /* Fade-in Animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
  
  `, "",{"version":3,"sources":["webpack://./src/components/Videos/VideoModal.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,iBAAiB;IACjD,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA,kBAAkB;EAClB;IACE,4BAA4B;IAC5B,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;EACpC;;;;EAIA,sCAAsC;AACxC;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW,EAAE,kBAAkB;IAC/B,YAAY;IACZ,iBAAiB;IACjB,gCAAgC,EAAE,uBAAuB;IACzD,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kBAAkB,EAAE,mBAAmB;IACvC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,qDAAqD;IACrD,2CAA2C,EAAE,kBAAkB;IAC/D,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,gCAAgC,EAAE,iBAAiB;IACnD,oCAAoC,EAAE,oBAAoB;AAC9D;;AAEA,wBAAwB;AACxB;IACI,qBAAqB,EAAE,qBAAqB;IAC5C,gCAAgC;AACpC;;EAEE,iBAAiB;EACjB;IACE,WAAW;IACX,iBAAiB;IACjB,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE;MACE,UAAU;MACV,qBAAqB;IACvB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF","sourcesContent":["/* Full-Screen Modal Background */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.7); /* Dark overlay */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n  }\n  \n  /* Modal Content */\n  .modal-content {\n    background: var(--clr-white);\n    padding: 2rem;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-4);\n    width: 90%;\n    max-width: 700px;\n    text-align: center;\n    position: relative;\n    animation: fadeIn 0.3s ease-in-out;\n  }\n  \n  \n  \n  /* Close Button - Stylish & Animated */\n.close-btn {\n    position: absolute;\n    top: 12px;\n    right: 15px;\n    width: 40px; /* Uniform shape */\n    height: 40px;\n    font-size: 1.3rem;\n    background: var(--clr-primary-6); /* Soft primary color */\n    color: var(--clr-white);\n    border: none;\n    cursor: pointer;\n    border-radius: 50%; /* Perfect circle */\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: transform 0.3s ease, background 0.3s ease;\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2); /* Subtle shadow */\n    z-index: 100;\n}\n\n/* Hover Animation */\n.close-btn:hover {\n    background: var(--clr-primary-4); /* Darker shade */\n    transform: scale(1.1) rotate(180deg); /* Rotating effect */\n}\n\n/* Active Click Effect */\n.close-btn:active {\n    transform: scale(0.9); /* Shrinks slightly */\n    background: var(--clr-primary-3);\n}\n\n  /* Video Player */\n  .modal-content video {\n    width: 100%;\n    max-height: 400px;\n    border-radius: var(--radius);\n    margin-top: 10px;\n  }\n  \n  /* Fade-in Animation */\n  @keyframes fadeIn {\n    from {\n      opacity: 0;\n      transform: scale(0.9);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }\n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
